import classnames from 'classnames';
import React, { FC } from 'react';
import { Text, TextButton } from '../..';
import { FileIcon } from '../../FileIcon';
import styles from './DragPreview.scss';
import { IOuter } from './DragPreview.types';

export const DragPreview: FC<IOuter> = ({ className, style, itemsCount = 0, item }) => (
  <div className={classnames(styles.dragPreview, className)} style={style}>
    <div className={styles.icon}>
      <FileIcon item={item} />
    </div>

    <Text weight="normal" size="small" className={styles.name}>
      {item.name}
    </Text>

    {itemsCount > 1 && (
      <TextButton as="div" className={styles.badge} size="small" weight="normal" underline="none">
        {itemsCount}
      </TextButton>
    )}
  </div>
);
